import type {
    BreadcrumbList,
    ListItem,
    SiteNavigationElement,
    WithContext,
    WPFooter,
    WPHeader,
    WPSideBar
} from 'schema-dts'
import { useRouter } from 'vue-router/composables'

import type{ VBreadcrumbItem } from '@/@types/vuetify'

import { localBusiness } from '@/common/json-ld/organization'
import { contextUrl, getAbsoluteUrl } from '@/common/json-ld/util'

const breadcrumbsItem = (breadcrumb: VBreadcrumbItem, position: number): ListItem => {
    const router = useRouter()

    if (breadcrumb.to) {
        return {
            '@type': 'ListItem',
            'position': position,
            'name': breadcrumb.text,
            'item': getAbsoluteUrl(router.resolve(breadcrumb.to).href)
        }
    }

    return {
        '@type': 'ListItem',
        'position': position,
        'name': breadcrumb.text
    }
}

const breadcrumbsList = (items: Array<VBreadcrumbItem>): WithContext<BreadcrumbList> => {
    return {
        '@context': contextUrl,
        '@type': 'BreadcrumbList',
        'itemListElement': items.map((item, idx) => {
            return breadcrumbsItem(item, idx + 1)
        })
    }
}

const footer = (): WithContext<WPFooter> => {
    return {
        '@context': contextUrl,
        '@type': 'WPFooter',
        'cssSelector': '.page-footer',
        'copyrightYear': 2016,
        'author': [
            {
                '@type': 'Person',
                'name': 'Michał Kleszczyński',
                'url': 'https://mkleszczynski.pl',
                'affiliation': localBusiness()
            },
            {
                '@type': 'Person',
                'name': 'Beata Kotra',
                'url': 'https://beatakotra.pl',
                'affiliation': localBusiness()
            }
        ]
    }
}

const header: WithContext<WPHeader> = {
    '@context': contextUrl,
    '@type': 'WPHeader',
    'cssSelector': '.page-header'
}

const sideBar: WithContext<WPSideBar> = {
    '@context': contextUrl,
    '@type': 'WPSideBar',
    'cssSelector': '.sidebar-container'
}

const siteNavElement: WithContext<SiteNavigationElement> = {
    '@context': contextUrl,
    '@type': 'SiteNavigationElement',
    'cssSelector': '.page-header nav ul'
}

export {
    breadcrumbsList,
    footer, header, sideBar, siteNavElement
}
